import useSWR from "swr"
import {API_TEAMS} from "../constants/apiUrls"

export default function useTeam(idTeam) {
    const {data, mutate, error} = useSWR(`${API_TEAMS}/${idTeam}`)
    return {
        team: data,
        mutateTeam: mutate,
        isLoadingTeam: !error && !data,
        isErrorTeam: error
    }
}